import { jsx as _jsx } from "react/jsx-runtime";
import { StripedDataGrid } from '../factories/DataGrid';
import { dateTimeNow } from '../NetworkSystem/cellFormatters/valueFormatters';
import { present, trueIsGood } from './boolean';
import { SystemReportTimeKeyToTimestamp } from './fns';
export const MultiReportStatus = ({ systemReports: systemReportsIn }) => {
    const systemReports = Object.fromEntries(Object.entries(systemReportsIn).filter(([timeKey, systemReport]) => !!systemReport));
    const columnarData = Object.entries(systemReports).map(([timekey, systemReport]) => {
        const timestamp = SystemReportTimeKeyToTimestamp(timekey);
        if (timestamp) {
            const { entityState, fanout, networkData, redis } = systemReport;
            const res = {
                id: String(timestamp),
                timestamp,
                databaseCachingPresent: redis.isPresent.verified,
                receivingNetworkMessages: networkData.sqsRecieving.verified,
                emittingProcessedDeviceMessages: networkData.deviceMessagesProduced.verified,
                emittingUpdatedEntityStates: entityState.emittingResults.verified,
                emittingDatabaseUpdates: fanout.isUpdatingRedis.verified,
                wideawakeUpdatingCache: redis.isReceivingDeviceUpdates.verified,
            };
            return res;
        }
        else {
            return null;
        }
    });
    const columnMap = {
        timestamp: { field: 'timestamp', headerName: 'Time', width: 200, valueFormatter: dateTimeNow },
        databaseCachingPresent: {
            field: 'databaseCachingPresent',
            align: 'center',
            headerAlign: 'center',
            headerName: 'Caching',
            description: 'Redis instance is caching the database',
            renderCell: present,
        },
        receivingNetworkMessages: {
            field: 'receivingNetworkMessages',
            align: 'center',
            headerAlign: 'center',
            headerName: 'Network',
            description: 'Network messages (uplinks) are being received',
            renderCell: trueIsGood,
        },
        emittingProcessedDeviceMessages: {
            field: 'emittingProcessedDeviceMessages',
            align: 'center',
            headerAlign: 'center',
            headerName: 'Device',
            description: 'Network messages (uplinks) are being processed',
            renderCell: trueIsGood,
        },
        emittingUpdatedEntityStates: {
            field: 'emittingUpdatedEntityStates',
            align: 'center',
            headerAlign: 'center',
            headerName: 'Entity',
            description: 'Entity State is being updated',
            renderCell: trueIsGood,
        },
        emittingDatabaseUpdates: {
            field: 'emittingDatabaseUpdates',
            align: 'center',
            headerAlign: 'center',
            headerName: 'Updating',
            description: 'Database updates are being sent to Redis instance',
            renderCell: trueIsGood,
        },
        wideawakeUpdatingCache: {
            field: 'wideawakeUpdatingCache',
            align: 'center',
            headerAlign: 'center',
            headerName: 'Monitoring',
            description: 'Redis instance is receiving device updates from Wideawake',
            renderCell: trueIsGood,
        },
    };
    const datagridProps = {
        columnHeaderHeight: 24,
        columns: Object.values(columnMap),
        disableColumnMenu: true,
        disableColumnResize: true,
        disableColumnSorting: true,
        rows: columnarData,
        rowHeight: 24,
    };
    return _jsx(StripedDataGrid, { ...datagridProps });
};
